<template>
    <div class="cluster-list-wrapper">
        <div class="cluster-manage-tip">
            <div>
                *{{ $t("zhiji.cluster.noteTip") }}<em :class="{ 'text-blue': $i18n.locale == 'cn' }">{{ $t("zhiji.cluster.blueFont") }}</em>
                <em :class="{ 'text-blue': $i18n.locale != 'cn' }">{{ $t("zhiji.cluster.dataTip") }}</em>
            </div>
            <div>
                <LangSelect :value="initLang" class="lang-select" @change="langChange"></LangSelect>
                <Search :placeholder="placeholderText" class="keyword-search" @searchChange="searchChange" @inputChange="fieldChange"></Search>
            </div>
        </div>
        <div class="cluster-card-box">
            <ClusterCard v-for="item in getCardData" :key="item.clusterId" @itemBtnClick="itemBtnClick" :cardData="item" />
        </div>
        <div class="page-control">
            <span class="wait-cluster">{{ cardTotal + $t("zhiji.cluster.todoCluster") }}</span>
            <PageControl
                v-if="cardTotal > 6"
                :total="cardTotal"
                :curPage="curPage"
                :lengthRank="pageLengthRank"
                :pageLength="pageLength"
                @pageChange="pageChange"
            />
        </div>
    </div>
</template>

<script>
import ClusterCard from "./ClusterCard";
import PageControl from "@/views/zhiji/bComponents/pageController/PageControl";
import Search from "@/views/zhiji/bComponents/inputs/Search";
import LangSelect from "@/components/langSelect";

export default {
    name: "ClusterList",
    props: ["data"],
    components: {
        ClusterCard,
        PageControl,
        Search,
        LangSelect
    },
    data() {
        return {
            curPage: 1,
            pageLength: 6,
            pageLengthRank: 6,
            clusterKeyword: "",
            initLang: "en"
        };
    },
    computed: {
        cardTotal() {
            return this.getStorePorp("cardTotals");
        },
        getCardData() {
            return this.data;
        },
        placeholderText() {
            return this.$t("zhiji.common.inputHolderLabel");
        }
    },
    methods: {
        pageChange(page) {
            if (this.curPage == page.curPage) {
                return;
            }
            this.curPage = page.curPage;
            this.$store.dispatch("zhiji/queryCardList", {
                page: page.curPage,
                field: this.clusterKeyword,
                lang: this.initLang
            });
        },
        getStorePorp(propName) {
            return this.$store.state.zhiji.questionCluster[propName];
        },
        searchChange(data) {
            this.curPage = 1;
            this.clusterKeyword = data.value;
            this.$store.dispatch("zhiji/queryCardList", {
                field: data.value,
                page: this.curPage,
                lang: this.initLang
            });
        },
        fieldChange(data) {
            this.clusterKeyword = data.value;
        },
        itemBtnClick() {
            this.$store.dispatch("zhiji/queryCardList", {
                page: this.curPage,
                field: this.clusterKeyword,
                lang: this.initLang
            });
        },
        langChange(data) {
            data = data === "all" ? "" : data;
            this.curPage = 1;
            this.initLang = data;
            this.$store.commit("zhiji/updateCurrentLang", data);
            this.$store.dispatch("zhiji/queryCardList", {
                lang: data,
                page: this.curPage
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.cluster-list-wrapper {
    height: 100%;
    background: #f2f7fb;

    .cluster-manage-tip {
        padding: 8px 40px;
        font-size: 12px;
        color: #41475e;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .text-blue {
            color: #2088f3;
        }
        .lang-select {
            margin-right: 3px;
            width: 150px;
            background: #fff;
        }
        .keyword-search {
            padding: 7px 0;
            width: 255px;
            background: #fff;
            margin-right: 10px;
        }
    }

    .cluster-card-box {
        display: flex;
        padding: 0 8px 0 16px;
        flex-wrap: wrap;
    }

    .page-control {
        width: 100%;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px 0 24px 0;
        text-align: center;
        color: rgba(65, 71, 94, 0.7);

        .wait-cluster {
            color: #9b9ba3;
            margin-right: 13px;
        }
    }
}
</style>
